'use strict';

import util from './util';

util.countryModal();
function Modal(modalCntr, modalBody, option) {
    this.$cntr = $(modalCntr);
    this.$body = $(modalBody);
    
    if($.isEmptyObject(option) === false){
    	this.modal = new Foundation.Reveal($(modalCntr), option);
    } else {
    	this.modal = new Foundation.Reveal($(modalCntr));
    }
    this.callbackFn = null;
    var modalInstance = this;
    this.$cntr.attr({
        role: 'dialog',
        'aria-modal': 'true',
        tabindex: '-1'
    });
    this.generatedAriaLabel = false;

    this.$cntr.on('open.zf.reveal', function () {
        $('html').addClass('modal-open');
        if (modalInstance.generatedAriaLabel) {
            modalInstance.$cntr.removeAttr('aria-label');
            modalInstance.generatedAriaLabel = false;
        }
        if (!modalInstance.$cntr.attr('aria-labelledby') && !modalInstance.$cntr.attr('aria-label')) {
            const title = modalInstance.$body.find('h1, h2, h3, h4, h5, h6').first().text().trim();
            if (title) {
                modalInstance.$cntr.attr('aria-label', title);
                modalInstance.generatedAriaLabel = true;
            }
        }
    });
    this.$cntr.on('closed.zf.reveal', function () {
        $('html').removeClass('modal-open');
    });

    this.events = {
        onOpen: function (cb) {
            modalInstance.$cntr.one('open.zf.reveal', cb);
            
        },

        onClose: function (cb) {
            modalInstance.$cntr.one('closed.zf.reveal', cb);
        }
    };
}

Modal.prototype.open = function () {
    this.modal.open();
};

Modal.prototype.close = function () {
    this.modal.close();
};

Modal.prototype.restoreDefaultClass = function () {
    this.$cntr.removeAttr('class');
    this.$cntr.attr('class','reveal');
    
    var customClass = $('body').attr('data-modal-class');
    if(customClass) {
        $('body').removeAttr('data-modal-class').removeClass('modal-open-'+customClass);
    }
};

Modal.prototype.addCustomClass = function(customClass){
    this.restoreDefaultClass();
    this.$cntr.addClass(customClass);
    $('body').attr('data-modal-class', customClass).addClass('modal-open-'+customClass);
};

Modal.prototype.setContent = function (content) {
    return this.$body.html(content);
};

Modal.prototype.renderContent = function(content, type) {
    var classType = type || '';

    this.$body.html('<div id="modal-content" class="modal-content ' + classType + '">' + content + '</div>');
    this.modal.open();
    
    if(typeof this.callbackFn === 'function') {
    	this.callbackFn();
    	this.callbackFn = null; // clear after each use
    }
};

Modal.prototype.renderByUrl = function (contentUrl) {
    return $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(this.renderContent.bind(this));
};

Modal.prototype.setCallback = function (cb) {
    this.callbackFn = cb;
};

export default {
    global: new Modal('#modal-cntr', '#modal-cntr .modal-body', {}), // global modal
    create: function (modalCntr, modalBody, option) {
        return new Modal(modalCntr, modalBody, option);
    }
};
